"use strict";
/**
 * This file was auto generated, please do not edit it directly.
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Payment = void 0;

var Payment =
/** @class */
function () {
  function Payment(restClient) {
    this.restClient = restClient;
  } // Queries

  /**
   * @param string - paymentId
   * @param string[]? - withData
   * @return Promise|Observable|any
   */


  Payment.prototype.GetPayment = function (paymentId, withData) {
    if (withData === void 0) {
      withData = null;
    }

    return this.restClient.get('Payment/UseCase/GetPayment', {
      paymentId: paymentId,
      withData: withData
    });
  };
  /**
   * @param string - eventId
   * @return Promise|Observable|any
   */


  Payment.prototype.GetPaymentTotalsForEvent = function (eventId) {
    return this.restClient.get('Payment/UseCase/GetPaymentTotalsForEvent', {
      eventId: eventId
    });
  };
  /**
   * @param string - eventId
   * @param string[]? - withData Refund|Purchase
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-100
   * @param string? - query
   * @param string? - sortBy
   * @param string? - sortDirection
   * @param any[]? - typeFilter transaction|ticket
   * @return Promise|Observable|any
   */


  Payment.prototype.ListPaymentsForEvent = function (eventId, withData, page, itemsPerPage, query, sortBy, sortDirection, typeFilter) {
    if (withData === void 0) {
      withData = null;
    }

    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    if (query === void 0) {
      query = null;
    }

    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    if (typeFilter === void 0) {
      typeFilter = null;
    }

    return this.restClient.get('Payment/UseCase/ListPaymentsForEvent', {
      eventId: eventId,
      withData: withData,
      page: page,
      itemsPerPage: itemsPerPage,
      query: query,
      sortBy: sortBy,
      sortDirection: sortDirection,
      typeFilter: typeFilter
    });
  }; // Commands

  /**
   * @param string - eventId
   * @param string - type
   * @param string - transType
   * @param string? - billingFirstName
   * @param string? - billingLastName
   * @param string? - billingAddress1
   * @param string? - billingAddress2
   * @param string? - billingCity
   * @param string? - billingState
   * @param string? - billingPostalCode
   * @param string? - billingCountry
   * @param string? - billingEmail
   * @param string? - billingPhone
   * @param string? - shippingFirstName
   * @param string? - shippingLastName
   * @param string? - shippingAddress1
   * @param string? - shippingAddress2
   * @param string? - shippingCity
   * @param string? - shippingState
   * @param string? - shippingPostalCode
   * @param string? - shippingCountry
   * @param string? - cardType
   * @param string? - cardNumber
   * @param string? - cardExpMon
   * @param string? - cardExpYear
   * @param string? - processingCurrency
   * @param number? - amount
   * @param number? - donationAmount
   * @param number? - shippingAmount
   * @param number? - promotionAmount
   * @param string? - transId
   * @param string? - transResult
   * @param string? - transOrderRef
   * @param string? - transMerchantProfile
   * @param string? - memo
   * @param string? - invoiceNo
   * @param boolean? - isOutside true|false
   * @param string? - paymentId
   * @return Promise|Observable|any
   */


  Payment.prototype.CreatePayment = function (eventId, type, transType, billingFirstName, billingLastName, billingAddress1, billingAddress2, billingCity, billingState, billingPostalCode, billingCountry, billingEmail, billingPhone, shippingFirstName, shippingLastName, shippingAddress1, shippingAddress2, shippingCity, shippingState, shippingPostalCode, shippingCountry, cardType, cardNumber, cardExpMon, cardExpYear, processingCurrency, amount, donationAmount, shippingAmount, promotionAmount, transId, transResult, transOrderRef, transMerchantProfile, memo, invoiceNo, isOutside, paymentId) {
    if (billingFirstName === void 0) {
      billingFirstName = null;
    }

    if (billingLastName === void 0) {
      billingLastName = null;
    }

    if (billingAddress1 === void 0) {
      billingAddress1 = null;
    }

    if (billingAddress2 === void 0) {
      billingAddress2 = null;
    }

    if (billingCity === void 0) {
      billingCity = null;
    }

    if (billingState === void 0) {
      billingState = null;
    }

    if (billingPostalCode === void 0) {
      billingPostalCode = null;
    }

    if (billingCountry === void 0) {
      billingCountry = null;
    }

    if (billingEmail === void 0) {
      billingEmail = null;
    }

    if (billingPhone === void 0) {
      billingPhone = null;
    }

    if (shippingFirstName === void 0) {
      shippingFirstName = null;
    }

    if (shippingLastName === void 0) {
      shippingLastName = null;
    }

    if (shippingAddress1 === void 0) {
      shippingAddress1 = null;
    }

    if (shippingAddress2 === void 0) {
      shippingAddress2 = null;
    }

    if (shippingCity === void 0) {
      shippingCity = null;
    }

    if (shippingState === void 0) {
      shippingState = null;
    }

    if (shippingPostalCode === void 0) {
      shippingPostalCode = null;
    }

    if (shippingCountry === void 0) {
      shippingCountry = null;
    }

    if (cardType === void 0) {
      cardType = null;
    }

    if (cardNumber === void 0) {
      cardNumber = null;
    }

    if (cardExpMon === void 0) {
      cardExpMon = null;
    }

    if (cardExpYear === void 0) {
      cardExpYear = null;
    }

    if (processingCurrency === void 0) {
      processingCurrency = null;
    }

    if (amount === void 0) {
      amount = null;
    }

    if (donationAmount === void 0) {
      donationAmount = null;
    }

    if (shippingAmount === void 0) {
      shippingAmount = null;
    }

    if (promotionAmount === void 0) {
      promotionAmount = null;
    }

    if (transId === void 0) {
      transId = null;
    }

    if (transResult === void 0) {
      transResult = null;
    }

    if (transOrderRef === void 0) {
      transOrderRef = null;
    }

    if (transMerchantProfile === void 0) {
      transMerchantProfile = null;
    }

    if (memo === void 0) {
      memo = null;
    }

    if (invoiceNo === void 0) {
      invoiceNo = null;
    }

    if (isOutside === void 0) {
      isOutside = null;
    }

    if (paymentId === void 0) {
      paymentId = null;
    }

    return this.restClient.post('Payment/UseCase/CreatePayment', {
      eventId: eventId,
      type: type,
      transType: transType,
      billingFirstName: billingFirstName,
      billingLastName: billingLastName,
      billingAddress1: billingAddress1,
      billingAddress2: billingAddress2,
      billingCity: billingCity,
      billingState: billingState,
      billingPostalCode: billingPostalCode,
      billingCountry: billingCountry,
      billingEmail: billingEmail,
      billingPhone: billingPhone,
      shippingFirstName: shippingFirstName,
      shippingLastName: shippingLastName,
      shippingAddress1: shippingAddress1,
      shippingAddress2: shippingAddress2,
      shippingCity: shippingCity,
      shippingState: shippingState,
      shippingPostalCode: shippingPostalCode,
      shippingCountry: shippingCountry,
      cardType: cardType,
      cardNumber: cardNumber,
      cardExpMon: cardExpMon,
      cardExpYear: cardExpYear,
      processingCurrency: processingCurrency,
      amount: amount,
      donationAmount: donationAmount,
      shippingAmount: shippingAmount,
      promotionAmount: promotionAmount,
      transId: transId,
      transResult: transResult,
      transOrderRef: transOrderRef,
      transMerchantProfile: transMerchantProfile,
      memo: memo,
      invoiceNo: invoiceNo,
      isOutside: isOutside,
      paymentId: paymentId
    });
  };
  /**
   * @param string - paymentId
   * @return Promise|Observable|any
   */


  Payment.prototype.DeletePayment = function (paymentId) {
    return this.restClient.post('Payment/UseCase/DeletePayment', {
      paymentId: paymentId
    });
  };

  return Payment;
}();

exports.Payment = Payment;